import { render, staticRenderFns } from "./EncuestasMainComponent.vue?vue&type=template&id=f91a0c78&"
import script from "./EncuestasMainComponent.vue?vue&type=script&lang=js&"
export * from "./EncuestasMainComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports